import {
  StyleSheet,
  TouchableOpacity,
  Modal,
  Button,
  Switch,
  TextInput as TextInputRN,
  FlatList,
  Alert,
  ScrollView,
  SafeAreaView,
  ActivityIndicator,
  Dimensions,
} from "react-native";
import { useFocusEffect } from "@react-navigation/native";
import { Dropdown } from "react-native-element-dropdown";
import { DatePickerModal } from "react-native-paper-dates";

import { Text, View } from "../../components/Themed";
import Icon from "react-native-vector-icons/AntDesign";
import IconEdit from "react-native-vector-icons/FontAwesome";
import IconEye from "react-native-vector-icons/Entypo";
import React, { useEffect, useState, useMemo, useRef } from "react";
import IconCross from "react-native-vector-icons/Entypo";
import AsyncStorage from "@react-native-async-storage/async-storage";
import AwesomeAlert from "react-native-awesome-alerts";
import { TextInput } from "react-native-paper";
import { baseUrl, postData } from "../../networking/api";
import { Provider as PaperProvider } from "react-native-paper";
import { Item } from "react-native-paper/lib/typescript/components/List/List";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import moment from "moment";
import Victory from "../../constants/victory";
import CustomSwitch from "../../components/CustomSwitch";
import IconFontAwesome from "react-native-vector-icons/FontAwesome";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import IconRefresh from "react-native-vector-icons/FontAwesome";
import { Subject } from "rxjs";
import { from } from "rxjs";

import { debounceTime, startWith, switchMap, tap } from "rxjs/operators";
const windowWidth = Dimensions.get("window").width;
const windowHeight = Dimensions.get("window").height;

export default function WaterAccumulation({ navigation }) {
  const [isVisible, setIsVisible] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [OmegeDeviceIds, setOmegeDeviceId] = useState();
  const [isAdd, setisAdd] = useState(false);
  var [counter, setCounter] = useState(1);
  const [sort, setsort] = useState(0);
  const [editpopup, setEditPopup] = useState(false);
  const [popid, setpopid] = useState("");
  const [popindex, setpopindex] = useState("");
  const [projectId, setProjectId] = useState("");
  const [projectCodeID, setProjectCode] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [OmegaIdData, setOmegaIdData] = useState([]);
  const [OmegavalueId, setOmegaValueiD] = useState("");
  const [OmegaId, setOmegaId] = useState("");

  const [ZoneNameData, setZoneNameData] = useState([]);
  const [ZoneValue, setZoneValue] = useState(null);
  const [ZoneValueId, setZoneValueId] = useState();
  const [SubzoneValue, setSubzoneValue] = useState();
  const [SubzoneValueId, setSubzoneValueId] = useState();
  const [subzoneData, setSubzoneData] = useState([]);
  const [OmegaIdValue, setOmegaIdValue] = useState<null | string>(null);
  const [OmegaError, setOmegaError] = useState("");
  const [isFocus, setIsFocus] = useState(false);

  const [graphOmegavalueId, setGraphOmegaValueiD] = useState("");
  const [graphOmegaId, setGraphOmegaId] = useState("");

  const [graphOmegaIdValue, setGraphOmegaIdValue] = useState(null);
  const [graphOmegaError, setGraphOmegaError] = useState("");
  const [isgraphFocus, setGraphIsFocus] = useState(false);

  const [alertTypeValue, setAlertTypeValue] = useState("");

  var idProject = useSelector((state) => state.idUpdating);
  var projectCodeId = useSelector((state) => state.projectCodeId);

  const [showAlert, setAlert] = useState(false);
  const [isOmegeDeviceNameValid, setOmegeDeviceNameDataValid] = useState(false);
  const [isOmegeDeviceNameEntered, setOmegeDeviceNameDataEntered] =
    useState(false);
  const [OmegeDeviceName, setOmegeDeviceNameData] = useState([]);
  const [OmegeDeviceByName, setOmegeDeviceByName] = useState("");
  const [error, setError] = useState("");
  const textOmegeDeviceName = useRef("");
  const [OmegeDeviceLength, setOmegeDeviceLength] = useState(0);
  const [searchData, setSearch] = useState("");
  const [isLoadingSync, setIsLoadingSync] = useState(true);

  const [filterData, setFilteredDataSource] = useState([]);

  const [isGraphicalViewOpen, setisGraphicalViewOpen] = React.useState(false);

  const [graphFromDate, setGraphFromDate] = React.useState<Date | undefined>(
    new Date(),
  );
  const [graphFromOpen, setGraphFromOpen] = React.useState(false);

  const [graphToDate, setGraphToDate] = React.useState<Date | undefined>(
    new Date(),
  );
  const [graphToOpen, setGraphToOpen] = React.useState(false);

  const [graphFromDateError, setGraphFromDateError] = useState("");
  const [graphToDateError, setGraphToDateError] = useState("");

  const [programGraphData, setProgramGraphData] = useState({});
  const [IsReportSynce, setIsReportSynce] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [alertData, setAlertData] = useState([
    {
      name: "All",
      value: "0",
    },
    {
      name: "General Error",
      value: "general_error",
    },
    {
      name: "Reset Reason",
      value: "unit_reset",
    },
    {
      name: "Low Battery",
      value: "low_battery",
    },
    {
      name: "Critical Low Battery",
      value: "critical_low_battery",
    },
    {
      name: "Modem Error",
      value: "modem_error",
    },
    {
      name: "SIM Error",
      value: "general_error",
    },
    {
      name: "RSSI + Cellular provider",
      value: "general_error",
    },
    {
      name: "Start FOTA",
      value: "start_fota",
    },
    {
      name: "End FOTA",
      value: "end_fota",
    },
    {
      name: "Modem Connect",
      value: "modem_connect",
    },
    {
      name: "Modem Disconnect",
      value: "modem_disconnect",
    },
    {
      name: "Configuration Error",
      value: "configuration_error",
    },
    {
      name: "Unit Started",
      value: "unit_started",
    },
    {
      name: "Program enqueue",
      value: "program_enqueue",
    },
    {
      name: "Program dequeued",
      value: "program_dequeued",
    },
    {
      name: "Capacitor failure",
      value: "capacitor_failure",
    },
    {
      name: "battery check",
      value: "battery_voltage",
    },
    {
      name: "Analog Error28",
      value: "analog_error",
    },
    {
      name: " Unit disconnect from the server",
      value: "unit_started",
    },
    {
      name: "Modbus Error",
      value: "program_enqueue",
    },
    {
      name: "Open Valve",
      value: "valve_open",
    },
    {
      name: "Close Valve",
      value: "valve_close",
    },
    {
      name: "Open Fertigation",
      value: "fertigation_open",
    },
    {
      name: "Close Fertigation",
      value: "fertigation_close",
    },
  ]);

  const [isPressAlert, setIsPressAlert] = useState(false);
  const [isPressOmega, setIsPressOmega] = useState(false);

  const [FromDateError, setFromDateError] = useState("");
  const [ToDateError, setToDateError] = useState("");

  const optionsPerPage = [10, 25, 50, 100];

  const [page, setPage] = React.useState(0);
  const [itemsPerPage, setItemsPerPage] = React.useState(optionsPerPage[0]);
  const fromm = page * itemsPerPage;
  const to = Math.min((page + 1) * itemsPerPage, OmegeDeviceLength);
  const screenwidth = Dimensions.get("window").width;
  const isMobile = screenwidth < 768;
  React.useEffect(() => {
    setIsPressOmega(true);
    setPage(0);
    setpopindex("");
    setEditPopup(false);
    setpopid("");
  }, [itemsPerPage]);
  const isCreatable = () => {
    setIsVisible(true);
    setisAdd(true);
  };

  var alpha_pattern = new RegExp(/^[a-zA-Z]+(\s[a-zA-Z]+)?$/);

  const [FromDate, setFromDate] = React.useState<Date | undefined>(new Date());
  const [FromOpen, setFromOpen] = React.useState(false);

  const onDismissGraphFrom = React.useCallback(() => {
    setGraphFromOpen(false);
  }, [setGraphFromOpen]);

  const onConfirmGraphFrom = React.useCallback(
    (params: { date: React.SetStateAction<Date | undefined> }) => {
      setGraphFromOpen(false);
      setGraphFromDateError("");
      setGraphFromDate(params.date);
    },
    [setGraphFromOpen, setGraphFromDate],
  );

  const onDismissGraphTo = React.useCallback(() => {
    setGraphToOpen(false);
  }, [setGraphToOpen]);

  const onConfirmGraphTo = React.useCallback(
    (params: { date: React.SetStateAction<Date | undefined> }) => {
      setGraphToOpen(false);
      setGraphToDateError("");
      setGraphToDate(params.date);
    },
    [setGraphToOpen, setGraphToDate],
  );

  const onDismissFrom = React.useCallback(() => {
    setFromOpen(false);
  }, [setFromOpen]);

  const onConfirmFrom = React.useCallback(
    async (params: { date: React.SetStateAction<Date | undefined> }) => {
      setFromOpen(false);
      setFromDateError("");
      setFromDate(params.date);
    },
    [setFromOpen, setFromDate],
  );

  const [ToDate, setToDate] = React.useState<Date | undefined>(new Date());
  const [ToOpen, setToOpen] = React.useState(false);
  const omegaChange$ = useRef(
    new Subject<{
      omegaId;
      zoneId;
      subzoneId;
      fromDate;
      toDate;
    }>(),
  );

  const onDismissTo = React.useCallback(() => {
    setToOpen(false);
  }, [setToOpen]);

  const onConfirmTo = React.useCallback(
    async (params: { date: React.SetStateAction<Date | undefined> }) => {
      setToOpen(false);
      setToDateError("");
      setToDate(params.date);
    },
    [setToOpen, setToDate],
  );

  const dropdownRefOmegaiD = useRef();
  const closeMenu = () => {
    dropdownRefOmegaiD.current.close();
  };

  useEffect(() => {
    window.addEventListener("scroll", closeMenu);
    return () => window.removeEventListener("scroll", closeMenu);
  }, []);
  useEffect(() => {

    omegaChange$.current.next({
      omegaId: OmegaId,
      zoneId: ZoneValueId,
      subzoneId: SubzoneValueId,
      fromDate: FromDate,
      toDate: ToDate,
    });
  }, [ZoneValueId, SubzoneValueId, OmegaId, FromDate, ToDate, IsReportSynce]);

  useEffect(() => {
    getProgramGraphData(graphOmegaId);
  }, [graphFromDate, graphToDate]);

  useFocusEffect(
    React.useCallback(() => {
      setIsPressOmega(true);
      searchFilterFunction("");
    }, [projectCodeId, projectCodeID, OmegaId]),
  );
  useFocusEffect(
    React.useCallback(() => {
      getAdminData();
    }, []),
  );

  const getAdminData = async () => {
    let jsonValue = await AsyncStorage.getItem("userData");
    let proCodeId = await AsyncStorage.getItem("projectCode");
    let proCode = JSON.parse(proCodeId);
    setProjectCode(proCode);
    getProgramGraphData("");
    let projValue = await AsyncStorage.getItem("projectData");

    if (projValue != null) {
      setProjectId(projValue);
      getOmegaDependentByProjectId(projValue, null, null);
      getAllZoneProfileData(projValue);
      getDependentZoneMaster(null);
    } else if (jsonValue != null) {
      var userDetailsresponse = JSON.parse(jsonValue);

      setProjectId(userDetailsresponse.project_selected);
      getOmegaDependentByProjectId(
        userDetailsresponse.project_selected,
        null,
        null,
      );
      getAllZoneProfileData(userDetailsresponse.project_selected);
      getDependentZoneMaster(null);
    }
  };

  const getDownloadExcel = async () => {
    const formatDate = (dateStr) => {
      const d = new Date(dateStr);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const uniqueDates = [
      ...new Set(OmegeDeviceName.map((item) => formatDate(item.dateTime))),
    ];

    const mergedData = [];
    OmegeDeviceName.forEach((item) => {
      const formattedDate = formatDate(item.dateTime);
      const existing = mergedData.find(
        (r) => r["Omega name"] === item.unitName,
      );
      const value = item.sumAmount;

      if (existing) {
        existing[formattedDate] = (existing[formattedDate] || 0) + value;
      } else {
        const newRow = {
          "Omega name": item.unitName,
          "Entity Name": item.entityName,
          "Zone Name": item.zone_name,
          "Subzone Name": item.sub_zone_name,
          Description: item.description,
        };
        uniqueDates.forEach(
          (d) => (newRow[d] = d === formattedDate ? value : 0),
        );
        mergedData.push(newRow);
      }
    });

    const formatNumber = (num) =>
      isNaN(num) || num === 0 ? "0" : num.toFixed(1);

    mergedData.forEach((row) => {
      const total = uniqueDates.reduce(
        (sum, d) => sum + Number(row[d] || 0),
        0,
      );
      row["Total (m³)"] = formatNumber(total);
      uniqueDates.forEach((d) => {
        row[d] = formatNumber(Number(row[d] || 0));
      });
    });

    mergedData.forEach((row, index) => {
      row["Sr. No"] = index + 1;
    });

    const totalRow = {
      "Sr. No": "Total",
      "Omega name": "",
      "Entity Name": "",
      "Zone Name": "",
      "Subzone Name": "",
      Description: "",
    };

    uniqueDates.forEach((d) => {
      const colTotal = mergedData.reduce(
        (sum, r) => sum + Number(r[d] || 0),
        0,
      );
      totalRow[d] = formatNumber(colTotal);
    });

    const descTotal = mergedData.reduce((sum, r) => {
      const descNum = Number(r.Description);
      return !isNaN(descNum) ? sum + descNum : sum;
    }, 0);
    totalRow.Description = descTotal > 0 ? formatNumber(descTotal) : "-";

    const grandTotal = uniqueDates.reduce(
      (sum, d) => sum + Number(totalRow[d] || 0),
      0,
    );
    totalRow["Total (m³)"] = formatNumber(grandTotal);

    const renamedMergedData = mergedData.map((row) => {
      const newRow = {};
      Object.keys(row).forEach((key) => {
        if (uniqueDates.includes(key)) {
          newRow[`${key} (m³)`] = row[key];
        } else {
          newRow[key] = row[key];
        }
      });
      return newRow;
    });

    const renamedTotalRow = {};
    Object.keys(totalRow).forEach((key) => {
      if (uniqueDates.includes(key)) {
        renamedTotalRow[`${key} (m³)`] = totalRow[key];
      } else {
        renamedTotalRow[key] = totalRow[key];
      }
    });

    const finalData = [...renamedMergedData, renamedTotalRow];

    const columnOrder = [
      "Sr. No",
      "Omega name",
      "Entity Name",
      "Zone Name",
      "Subzone Name",
      "Description",
      ...uniqueDates.map((d) => `${d} (m³)`),
      "Total (m³)",
    ];

    const orderedData = finalData.map((row) => {
      const orderedRow = {};
      columnOrder.forEach((col) => {
        orderedRow[col] = row[col] ?? "";
      });
      return orderedRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(orderedData, {
      header: columnOrder,
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const excelBuffer = XLSX.write(workbook, {
      type: "array",
      bookType: "xlsx",
    });

    const excelData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(excelData, "WaterAccumulation_Report.xlsx");
  };

  const getOmegaDependentByProjectId = async (
    projectID,
    zone_id,
    sub_zone_id,
  ) => {
    setIsLoading(true);
    try {
      var OmegaIdData = JSON.stringify({
        column: "project_id",
        value: projectID,
        module: "devices_master",
        zone_id: zone_id,
        sub_zone_id: sub_zone_id,
        isUpdate: true,
      });
      const OmegaIdList = await postData(
        OmegaIdData,
        "masters/getDependentMasterList",
      );
      setIsLoading(false);
      var code = OmegaIdList.code;
      if (code == 1) {
        var mergeData = OmegaIdList.data;
        mergeData.unshift({
          id: 0,
          project_id: projectId,
          omega_id: "",
          device_name: "All",
          lat: "",
          long: "",
          active: 1,
        });
        setOmegaIdValue("All");
        setOmegaIdData(mergeData);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const getAllZoneProfileData = async (pid) => {
    setIsLoading(true);
    try {
      var getZoneData = JSON.stringify({
        condition: {
          project_id: pid,
        },
        module: "zone_master",
        relation: [],
        active: 1,
      });
      const ZoneNameResponse = await postData(
        getZoneData,
        "masters/getMasterList",
      );
      setIsLoading(false);
      var code = ZoneNameResponse.code;
      if (code == 1) {
        var mergeDataDrop = ZoneNameResponse.data;
        mergeDataDrop.unshift({
          zone_name: "All",
          active: 1,
          id: 0,
        });
        setZoneValue("All");
        setZoneNameData(mergeDataDrop);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const getDependentZoneMaster = async (zone_id) => {
    setIsLoading(true);

    try {
      var dependentData = JSON.stringify({
        column: "zone_id",
        value: zone_id,
        module: "sub_zone_master",
      });
      const dependentZoneRes = await postData(
        dependentData,
        "masters/getDependentMasterList",
      );
      setIsLoading(false);
      var code = dependentZoneRes.code;
      if (code == 1) {
        var mergeDataSubDrop = dependentZoneRes.data;
        mergeDataSubDrop.unshift({
          sub_zone_name: "All",
          active: 1,
          id: 0,
        });
        setSubzoneValue("All");
        setSubzoneValueId(0);
        setSubzoneData(mergeDataSubDrop);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const renderZoneIdListItems = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && <Text style={styles.textItem}>{item.zone_name}</Text>}
        {isAdd == false && (
          <Text style={styles.textItem}>{item.zone_name}</Text>
        )}
      </View>
    );
  };
  const renderSubZoneIdListItems = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && (
          <Text style={styles.textItem}>{item.sub_zone_name}</Text>
        )}
        {isAdd == false && (
          <Text style={styles.textItem}>{item.sub_zone_name}</Text>
        )}
      </View>
    );
  };
  const renderOmegaIdListItems = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {isAdd == false && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {item.id === OmegavalueId && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };

  const renderGraphOmegaIdListItems = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {isAdd == false && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {item.id === graphOmegavalueId && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };
  const searchFilterFunction = (text) => {
    if (text) {
      const newData = OmegeDeviceName.filter(function (item) {
        const itemData = item.OmegeDevice
          ? item.OmegeDevice.toUpperCase()
          : "".toUpperCase();
        const textData = text.toUpperCase();
        return itemData.indexOf(textData) > -1;
      });
      setFilteredDataSource(newData);
      setSearch(text);
      setPage(0);
    } else {
      setFilteredDataSource(OmegeDeviceName);
      setSearch(text);
      setPage(0);
    }
  };

  const searchQueryFunction = (text) => {
    if (text) {
      const textData = text.toUpperCase();

      const newData = OmegeDeviceName.filter((item) => {
        const zoneData = item.zone_name ? item.zone_name.toUpperCase() : "";
        const subzoneData = item.sub_zone_name
          ? item.sub_zone_name.toUpperCase()
          : "";
        return zoneData.includes(textData) || subzoneData.includes(textData);
      });

      setFilteredDataSource([...newData]);
    } else {
      setFilteredDataSource(OmegeDeviceName);
    }

    setSearchQuery(text);
    setPage(0);
  };

  var counter = 1;
  const customStyles = {
    rows: {
      style: {
        minHeight: "30px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        backgroundColor: "#319ef0a3",
        minHeight: "40px",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    headCells: {
      style: {
        justifyContent: "center",
        minHeight: "20px",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
        justifyContent: "center",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          fontSize: 16,
          fontWeight: "400",
          textTransform: "Capitalize",

        },
      },
    },
  };
  const caseInsensitiveSort = (rowA, rowB) => {
    const a = rowA.dateTime.toLowerCase();
    const b = rowB.dateTime.toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  const uniqueDates = [...new Set(filterData.map((item) => item?.dateTime))];

  const formatDate = (dateStr: string) => {
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const columnsOmega = [
    {
      name: "Sr. No",
      selector: (row, index) =>
        row?.isTotalRow
          ? "Total"
          : (currentPage - 1) * rowsPerPage + (index + 1),
      sortable: false,
      width: "80px",
    },
    {
      name: "Omega Name",
      selector: (row) => row?.unitName || "-",
      sortable: true,
    },
    {
      name: "Entity Name",
      selector: (row) => row?.entityName || "-",
      sortable: true,
    },
    {
      name: "Zone Name",
      selector: (row) => row?.zone_name || "-",
      sortable: true,
    },
    {
      name: "Subzone Name",
      selector: (row) => row?.sub_zone_name || "-",
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row?.description || "-",
      sortable: true,
      cell: (row) => (
        <div style={{ fontWeight: row.isTotalRow ? "bold" : "normal" }}>
          {row.description || "-"}
        </div>
      ),
    },

    ...uniqueDates.map((date) => ({
      name: formatDate(date) + " (m³)",
      selector: (row) => (row[date] ? Number(row[date]).toFixed(1) : "0"),
      sortable: true,
    })),
    {
      name: "Total (m³)",
      selector: (row) => {
        const total = uniqueDates.reduce(
          (sum, date) => sum + (Number(row[date]) || 0),
          0,
        );
        return total ? Number(total).toFixed(1) : "0";
      },
      sortable: true,
      style: {
        fontWeight: "bold",
        fontSize: "16px",
      },
    },
  ];
  const customSort = (rows, selector, direction) => {
    const totalRow = rows.find((r) => r.isTotalRow);
    const dataRows = rows.filter((r) => !r.isTotalRow);

    const sortedRows = [...dataRows].sort((a, b) => {
      const aValue = selector(a);
      const bValue = selector(b);

      const aNum = parseFloat(aValue);
      const bNum = parseFloat(bValue);

      if (!isNaN(aNum) && !isNaN(bNum)) {
        return direction === "asc" ? aNum - bNum : bNum - aNum;
      } else {
        return direction === "asc"
          ? String(aValue).localeCompare(String(bValue))
          : String(bValue).localeCompare(String(aValue));
      }
    });

    return totalRow ? [...sortedRows, totalRow] : sortedRows;
  };

  const transformedData = filterData.reduce((acc, item) => {
    let existing = acc.find((r) => r.unitName === item.unitName);
    if (!existing) {
      existing = {
        unitName: item.unitName,
        entityName: item.entityName,
        zone_name: item.zone_name,
        sub_zone_name: item.sub_zone_name,
        description: item.description,
      };
      acc.push(existing);
    }
    existing[item.dateTime] =
      (existing[item.dateTime] || 0) + (item.sumAmount || 0);
    return acc;
  }, []);

  const totalRow = useMemo(() => {
    const totals = {
      "sr. No": "Total",
      unitName: "",
      entityName: "",
      zone_name: "",
      sub_zone_name: "",
      description: "",
      isTotalRow: true,
    };

    uniqueDates.forEach((date) => {
      const sum = transformedData.reduce(
        (sum, row) => sum + (Number(row[date]) || 0),
        0,
      );
      totals[date] = sum.toFixed(1);
    });
    const descTotal = transformedData.reduce((sum, row) => {
      const descNum = Number(row.description);
      return !isNaN(descNum) ? sum + descNum : sum;
    }, 0);
    totals.description = descTotal > 0 ? descTotal.toFixed(1) : "-";

    totals.total = uniqueDates
      .reduce((sum, date) => sum + Number(totals[date]), 0)
      .toFixed(1);

    return totals;
  }, [uniqueDates, transformedData]);

  const tableDataWithTotal = useMemo(() => {
    const dataWithoutTotal = transformedData.filter((r) => !r.isTotalRow);
    return [...dataWithoutTotal, totalRow];
  }, [transformedData, totalRow]);

  const conditionalRowStyles = [
    {
      when: (row) => row.unitName === "Total" || row.isTotalRow,
      style: {
        fontWeight: "bold",

        backgroundColor: "#f3f4f6",
        color: "#000",
        borderTop: "2px solid #ccc",
      },
    },
  ];
  const INITIAL_PARAMS = {
    omegaId: null,
    zoneId: 0,
    subzoneId: 0,
    fromDate: new Date(),
    toDate: new Date(),
  };
  useEffect(() => {
    let controller = new AbortController();

    const subscription = omegaChange$.current
      .pipe(
        startWith(INITIAL_PARAMS), 
        debounceTime(300),
        tap(() => setIsLoadingSync(true)),
        switchMap(({ omegaId, zoneId, subzoneId, fromDate, toDate }) => {
          controller.abort();
          controller = new AbortController();

          return from(
            getOmegaDeviceData(
              omegaId,
              zoneId,
              subzoneId,
              fromDate,
              toDate,
              controller.signal,
            ),
          ).pipe(
            tap({
              error: (err) => {
                if (err.name !== "AbortError") setIsLoadingSync(false);
              },
              complete: () => setIsLoadingSync(false),
            }),
          );
        }),
      )
      .subscribe({
        error: (err) => {
          if (err.name === "AbortError") {
          } else {
            console.error(err);
          }
        },
      });

    return () => {
      controller.abort();
      subscription.unsubscribe();
    };
  }, []);

  const getOmegaDeviceData = async (
    omegaId,
    zoneId,
    subzoneId,
    fromDate,
    toDate,
    signal,
  ) => {

    try {
      let proCodeId = await AsyncStorage.getItem("projectCode");
      let proCode = JSON.parse(proCodeId);
      let projValue = await AsyncStorage.getItem("projectAllData");
      let projectData = projValue ? JSON.parse(projValue) : null;
      var OmegeDeviceData = JSON.stringify({
        from: fromDate,
        to: toDate,
        uid: omegaId,
        pid: proCode,
        zone_id: zoneId,
        sub_zone_id: subzoneId,
        project_id: projectData?.id,
      });

      const OmegeDeviceNameResponse = await postData(
        OmegeDeviceData,
        "reports/getLogsWaterMeterTs",
        signal,
      );
      var code = OmegeDeviceNameResponse.code;
      if (code == 1) {
        setIsPressOmega(true); 

        setOmegeDeviceNameData(OmegeDeviceNameResponse.data);
        setFilteredDataSource(OmegeDeviceNameResponse.data);
      } else {
        setOmegeDeviceNameData(OmegeDeviceNameResponse.data);
        setFilteredDataSource(OmegeDeviceNameResponse.data);

      }
    } catch (error) {
      console.error("Error", error);
    } finally {
    }
  };

  const getProgramGraphData = async (omega_id) => {
    let projValue = await AsyncStorage.getItem("projectData");
    let jsonValue = await AsyncStorage.getItem("userData");
    var userDetailsresponse = JSON.parse(jsonValue);
    let from_date = moment(graphFromDate).format("YYYY-MM-DD");
    let to_date = moment(graphToDate).format("YYYY-MM-DD");
    try {
      var OmegeDeviceData = JSON.stringify({
        project_id:
          projValue !== null ? projValue : userDetailsresponse.project_selected,
        startDate: from_date,
        endDate: to_date,
        omega_id: omega_id,
      });

      const programGraphResponse = await postData(
        OmegeDeviceData,
        "reports/graphWaterAccumulation",
      );

      var code = programGraphResponse.code;
      if (code == 1) {
        setProgramGraphData(programGraphResponse.data);
      } else {
        setProgramGraphData(programGraphResponse.data);

      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const onSelectSwitch = (index) => {
    if (isGraphicalViewOpen) {
      setOmegaId("");
      setGraphOmegaId("");
      setisGraphicalViewOpen(false);
    } else {
      setOmegaId("");
      setGraphOmegaId("");
      setisGraphicalViewOpen(true);
    }
  };

  const getReportSync = async () => {
    setIsReportSynce(true);
    try {
      let proCodeId = await AsyncStorage.getItem("projectCode");
      let proCode = JSON.parse(proCodeId);
      let projValue = await AsyncStorage.getItem("projectAllData");
      let projectData = projValue ? JSON.parse(projValue) : null;
      const data = JSON.stringify({
        from: FromDate,
        to: ToDate,
        uid: null,
        pid: proCode,
        isSync: true,
        project_id: projectData?.id,
      });

      const OmegeDeviceNameResponse = await postData(
        data,
        "reports/waterAccumulation",
      );
      var code = OmegeDeviceNameResponse.code;
      if (OmegeDeviceNameResponse) {
        setIsReportSynce(false);
      } else {
        setIsReportSynce(false);
      }
    } catch (error) {
      setIsReportSynce(false);
      console.error("Error", error);
    }
  };

  return (
    <SafeAreaView>
      <ScrollView showsVerticalScrollIndicator={false}>
        <View
          style={
            isMobile
              ? [styles.container, { marginTop: "-15%" }]
              : [styles.container, { backgroundColor: "#fff" }]
          }
        >
          <View
            style={
              isMobile
                ? {
                    flexDirection: "row",
                    width: "100%",
                    marginTop: "65%",
                    backgroundColor: "#fff",
                  }
                : {
                    flexDirection: "row",
                    width: "100%",
                    marginTop: "10%",
                    backgroundColor: "#fff",
                  }
            }
          >
            <View
              style={
                isMobile
                  ? { backgroundColor: "#fff" }
                  : { margin: 10, backgroundColor: "#fff" }
              }
            >
              <Text style={styles.lableText}>
                Reports {">"}{" "}
                <Text
                  style={{ color: "#000000" }}
                  onPress={() => navigation.navigate("WaterAccumulation")}
                >
                  {" "}
                  Water Accumulation{" "}
                </Text>
              </Text>
            </View>
            <View
              style={
                isMobile
                  ? {
                      position: "absolute",
                      right: 0,
                      top: 50,
                      backgroundColor: "#fff",
                      left: "8%",
                    }
                  : {
                      position: "absolute",
                      right: 0,
                      top: 10,
                      backgroundColor: "#fff",
                    }
              }
            >
              <CustomSwitch
                selectionMode={1}
                roundCorner={true}
                option1={"Table View"}
                option2={"Graphical View"}
                onSelectSwitch={onSelectSwitch}
                selectionColor={"#006EB9"}
              />
            </View>
          </View>
          {!isGraphicalViewOpen ? (
            <View
              style={
                isMobile
                  ? {
                      height: "100%",
                      width: "100%",
                      backgroundColor: "#fff",
                      marginTop: 80,
                    }
                  : {
                      height: "100%",
                      width: "100%",
                      backgroundColor: "#fff",
                    }
              }
            >
              <View
                style={
                  isMobile
                    ? {
                        flexDirection: "row",
                        width: "100%",
                        marginTop: "1%",
                        marginLeft: 2,
                        backgroundColor: "#fff",
                      }
                    : {
                        flexDirection: "row",
                        width: "100%",
                        marginTop: "0%",
                        marginLeft: 10,
                        backgroundColor: "#fff",
                      }
                }
              >
                <View
                  style={
                    isMobile
                      ? { width: "45%", backgroundColor: "#fff" }
                      : { width: "15%", backgroundColor: "#fff" }
                  }
                >
                  <Text
                    style={
                      isMobile
                        ? { color: "#000000", fontSize: 12 }
                        : { color: "#000000" }
                    }
                  >
                    From Date
                  </Text>
                  <View
                    style={{
                      flexDirection: "column",
                      marginTop: 5,
                      backgroundColor: "#fff",
                    }}
                  >
                    <Text
                      style={styles.input}
                      onPress={() => setFromOpen(true)}
                    >
                      {isMobile
                        ? moment(FromDate).format("DD/MM/YY")
                        : moment(FromDate).format("DD/MM/YYYY")}
                    </Text>
                    <Text style={styles.error_text}>{FromDateError}</Text>
                  </View>
                </View>

                <DatePickerModal
                  locale="en"
                  mode="single"
                  visible={FromOpen}
                  onDismiss={onDismissFrom}
                  date={FromDate}
                  onConfirm={onConfirmFrom}
                  label="Select date" 
                  closeIcon="close"
                  calendarIcon="calendar"
                />

                <View
                  style={
                    isMobile
                      ? {
                          width: "30%",
                          backgroundColor: "#fff",
                          marginLeft: "-10%",
                        }
                      : {
                          width: "15%",
                          backgroundColor: "#fff",
                          marginLeft: 10,
                        }
                  }
                >
                  <Text
                    style={
                      isMobile
                        ? { color: "#000000", fontSize: 12 }
                        : { color: "#000000" }
                    }
                  >
                    To Date
                  </Text>
                  <View
                    style={{
                      flexDirection: "column",
                      marginTop: 5,
                      backgroundColor: "#fff",
                    }}
                  >
                    <Text style={styles.input} onPress={() => setToOpen(true)}>
                      {isMobile
                        ? moment(ToDate).format("DD/MM/YY")
                        : moment(ToDate).format("DD/MM/YYYY")}
                    </Text>
                    <Text style={styles.error_text}>{ToDateError}</Text>
                  </View>
                </View>
                <DatePickerModal
                  locale="en"
                  mode="single"
                  visible={ToOpen}
                  onDismiss={onDismissTo}
                  date={ToDate}
                  onConfirm={onConfirmTo}
                  label="Select date" 
                  closeIcon="close"
                  calendarIcon="calendar"
                />
                <View
                  style={
                    isMobile
                      ? {
                          width: "30%",
                          backgroundColor: "#fff",
                          marginLeft: "-10%",
                        }
                      : {
                          marginLeft: 10,
                          width: "15%",
                          backgroundColor: "#fff",
                        }
                  }
                >
                  <Text
                    style={
                      isMobile
                        ? { color: "#000000", fontSize: 12 }
                        : { color: "#000000" }
                    }
                  >
                    Select Zone
                  </Text>
                  <Dropdown
                    style={styles.dropdown}
                    placeholderStyle={
                      isMobile ? { fontSize: 12 } : styles.placeholderStyle
                    }
                    selectedTextStyle={styles.selectedTextStyle}
                    inputSearchStyle={styles.inputSearchStyle}
                    iconStyle={styles.iconStyle}
                    data={ZoneNameData}
                    search
                    maxHeight={300}
                    labelField="zone_name"
                    valueField="zone_name"
                    placeholder={!isFocus ? "Select Zone Id" : "...."}
                    searchPlaceholder="Search..."
                    value={ZoneValue}
                    onChange={(item) => {
                      setZoneValue(item.zone_name);
                      setZoneValueId(item.id);

                      setSubzoneValue("All");
                      setSubzoneValueId(0);
                      setOmegaIdValue("All");
                      setOmegaValueiD(0);
                      setOmegaId("");

                      getDependentZoneMaster(item.id);
                      getOmegaDependentByProjectId(projectId, item.id, null);

                      omegaChange$.current.next({
                        omegaId: "",
                        zoneId: item.id,
                        subzoneId: 0,
                        fromDate: FromDate,
                        toDate: ToDate,
                      });
                    }}
                    renderItem={renderZoneIdListItems}
                  />
                </View>
                <View
                  style={
                    isMobile
                      ? {
                          width: "30%",
                          backgroundColor: "#fff",
                          marginLeft: "-10%",
                        }
                      : {
                          marginLeft: 10,
                          width: "15%",
                          backgroundColor: "#fff",
                        }
                  }
                >
                  <Text
                    style={
                      isMobile
                        ? { color: "#000000", fontSize: 12 }
                        : { color: "#000000" }
                    }
                  >
                    Select Subzone
                  </Text>
                  <Dropdown
                    ref={dropdownRefOmegaiD}
                    style={styles.dropdown}
                    placeholderStyle={
                      isMobile ? { fontSize: 12 } : styles.placeholderStyle
                    }
                    selectedTextStyle={styles.selectedTextStyle}
                    inputSearchStyle={styles.inputSearchStyle}
                    iconStyle={styles.iconStyle}
                    data={subzoneData}
                    search
                    maxHeight={300}
                    labelField="sub_zone_name"
                    valueField="sub_zone_name"
                    placeholder={!isFocus ? "Select subzone " : "...."}
                    searchPlaceholder="Search..."
                    value={SubzoneValue}
                    onChange={(item) => {
                      setSubzoneValue(item.sub_zone_name);
                      setSubzoneValueId(item.id);
                      setOmegaIdValue("All");
                      setOmegaValueiD(0);
                      setOmegaId("");
                      getOmegaDependentByProjectId(
                        projectId,
                        ZoneValueId,
                        item.id,
                      );
                      omegaChange$.current.next({
                        omegaId: "",
                        zoneId: ZoneValueId,
                        subzoneId: item.id,
                        fromDate: FromDate,
                        toDate: ToDate,
                      });
                    }}
                    renderItem={renderSubZoneIdListItems}
                  />
                </View>
                <View
                  style={
                    isMobile
                      ? {
                          width: "30%",
                          backgroundColor: "#fff",
                          marginLeft: "-10%",
                        }
                      : {
                          marginLeft: 10,
                          width: "15%",
                          backgroundColor: "#fff",
                        }
                  }
                >
                  <Text
                    style={
                      isMobile
                        ? { color: "#000000", fontSize: 12 }
                        : { color: "#000000" }
                    }
                  >
                    Select Omega
                  </Text>
                  <Dropdown
                    ref={dropdownRefOmegaiD}
                    style={styles.dropdown}
                    placeholderStyle={
                      isMobile ? { fontSize: 12 } : styles.placeholderStyle
                    }
                    selectedTextStyle={styles.selectedTextStyle}
                    inputSearchStyle={styles.inputSearchStyle}
                    iconStyle={styles.iconStyle}
                    data={OmegaIdData}
                    search
                    maxHeight={300}
                    labelField="device_name"
                    valueField="device_name"
                    placeholder={!isFocus ? "Omega Device Type" : "...."}
                    searchPlaceholder="Search..."
                    value={OmegaIdValue}
                    onChange={(item) => {
                      setOmegaIdValue(item.device_name);
                      setOmegaValueiD(item.id);
                      if (FromDate === undefined && ToDate === undefined) {
                        setFromDateError("Please select from data");
                        setToDateError("Please select to date");
                      } else {
                        setOmegaId(item.omega_id);
                        omegaChange$.current.next({
                          omegaId: item.omega_id,
                          zoneId: ZoneValueId,
                          subzoneId: SubzoneValueId,
                          fromDate: FromDate,
                          toDate: ToDate,
                        });
                        setFromDateError("");
                        setToDateError("");
                      }
                    }}
                    renderItem={renderOmegaIdListItems}
                  />
                </View>
                <View style={{ marginRight: 5 }}>
                  {IsReportSynce ? (
                    <ActivityIndicator
                      color="#1DA1F2"
                      visible={IsReportSynce}
                      textContent={"Loading..."}
                      size={40}
                    />
                  ) : (
                    <View style={{ width: 25, height: 25 }}>
                      <TouchableOpacity
                        style={{
                          backgroundColor: "red",
                          margin: 15,
                          marginBottom: 20,
                        }}
                        onPress={() => getReportSync()}
                      >
                        <IconRefresh name="refresh" size={25} />
                      </TouchableOpacity>
                    </View>
                  )}
                </View>
                <View
                  style={
                    isMobile
                      ? {
                          margin: "20%",
                          alignItems: "flex-end",
                          marginTop: "25%",
                          backgroundColor: "#fff",
                          width: "65%",
                          marginLeft: "-65%",
                        }
                      : {
                          alignItems: "flex-end",
                          margin: 20,
                          flex: 1,
                          backgroundColor: "#fff",
                        }
                  }
                >
                  {OmegeDeviceName.length > 0 && (
                    <TouchableOpacity
                      style={
                        isMobile
                          ? {
                              alignItems: "center",
                              backgroundColor: "#747474",
                              padding: 10,
                              borderWidth: 1,
                              borderColor: "#747474",
                              width: "65%",
                              borderRadius: 10,
                              marginBottom: "-40%",
                            }
                          : styles.alertBtn
                      }
                      onPress={() => {
                        getDownloadExcel();
                      }}
                    >
                      <Text style={styles.btnText}>
                        <Icon name="exclefile1" size={15} color="#fff" />{" "}
                        Download
                      </Text>
                    </TouchableOpacity>
                  )}
                </View>
              </View>
              <View
                style={
                  isMobile
                    ? { marginLeft: "2%", width: "30%" }
                    : {
                        marginLeft: "1%",
                        width: "100%",
                        flexDirection: "row", 
                        justifyContent: "flex-end",
                        paddingRight: 40,
                      }
                }
              >
                <View style={{ marginVertical: 4 }}>
                  <TextInput
                    value={searchQuery}
                    style={{
                      height: 35,
                      borderWidth: 1.5,
                      paddingLeft: 1,
                      margin: 0,
                      borderColor: "#c3c3c3",
                      backgroundColor: "#FFFFFF",
                      width: "100%",
                      borderRadius: 5,
                      color: "#000",
                      fontWeight: "400",
                    }}
                    underlineColor={"white"}
                    theme={{
                      colors: {
                        text: "black",
                        primary: "white",
                        background: "transparent",
                      },
                    }}
                    underlineColorAndroid="transparent"
                    placeholder="Search by zone & subzone"
                    onChangeText={(text: string) => searchQueryFunction(text)}
                  />
                </View>
              </View>
              <View
                style={
                  isMobile
                    ? [
                        styles.card,
                        {
                          flexGrow: 1,
                          backgroundColor: "#fff",
                          marginTop: "-3%",
                        },
                      ]
                    : [styles.card, { flexGrow: 1, backgroundColor: "#fff" }]
                }
              >
                <View
                  style={
                    isMobile
                      ? [
                          styles.shadowProp,
                          {
                            width: "140%",
                            backgroundColor: "#F6F9F9",
                          },
                        ]
                      : [
                          styles.shadowProp,
                          {
                            width: "140%",
                            backgroundColor: "#F6F9F9",
                          },
                        ]
                  }
                >
                  <View style={{ backgroundColor: "#fff" }}>
                    {isPressAlert == true && (
                      <DataTable
                        columns={columnsAlert}
                        data={filterData}
                        customStyles={customStyles}
                        pagination
                        defaultSortFieldId={"OmegeDevice"}
                        defaultSortAsc={true}
                      />
                    )}
                    {isPressOmega == true &&
                      (isLoadingSync ? (
                        <ActivityIndicator
                          color="#1DA1F2"
                          visible={isLoadingSync}
                          textContent={"Loading..."}
                          size={100}
                        />
                      ) : filterData.length > 0 ? (
                        <DataTable
                          columns={columnsOmega}
                          data={tableDataWithTotal}
                          customStyles={customStyles}
                          pagination
                          defaultSortFieldId={"OmegeDevice"}
                          sortFunction={customSort}
                          defaultSortAsc={true}
                          conditionalRowStyles={conditionalRowStyles}
                          paginationPerPage={rowsPerPage}
                          onChangeRowsPerPage={(newPerPage, page) => {
                            setRowsPerPage(newPerPage);
                            setCurrentPage(page);
                          }}
                          onChangePage={(page) => setCurrentPage(page)}
                        />
                      ) : (
                        <View
                          style={{
                            justifyContent: "center",
                            backgroundColor: "#fff",
                          }}
                        >
                          <Text
                            style={[
                              styles.emptyListStyle,
                              {
                                alignSelf: "center",
                                marginTop: 20,
                                color: "#000000",
                              },
                            ]}
                          >
                            No Water Accumulation data Found{" "}
                          </Text>
                        </View>
                      ))}
                  </View>
                </View>
              </View>
            </View>
          ) : (
            <View
              style={
                isMobile
                  ? {
                      height: "100%",
                      width: "120%",
                      marginTop: "20%",
                      backgroundColor: "#fff",
                    }
                  : {
                      height: "100%",
                      width: "100%",
                      marginBottom: 50,
                      backgroundColor: "#fff",
                    }
              }
            >
              <View
                style={{
                  margin: 20,
                  shadowColor: "#171717",
                  shadowOffset: { width: -2, height: 4 },
                  shadowOpacity: 0.2,
                  shadowRadius: 15,
                  padding: 20,
                  backgroundColor: "#fff",
                }}
              >
                <View
                  style={
                    isMobile
                      ? {
                          flexDirection: "row",
                          width: "100%",
                          marginTop: "1%",
                          marginLeft: 2,
                          backgroundColor: "#fff",
                        }
                      : {
                          flexDirection: "row",
                          width: "100%",
                          marginTop: "0%",
                          marginLeft: 20,
                          backgroundColor: "#fff",
                        }
                  }
                >
                  <View
                    style={
                      isMobile
                        ? { width: "45%", backgroundColor: "#fff" }
                        : {
                            width: "15%",
                            backgroundColor: "#fff",
                          }
                    }
                  >
                    <Text
                      style={
                        isMobile
                          ? { color: "#000000", fontSize: 12 }
                          : { color: "#000000" }
                      }
                    >
                      From Date
                    </Text>
                    <View
                      style={{
                        flexDirection: "column",
                        marginTop: 2,
                        backgroundColor: "#fff",
                      }}
                    >
                      <Text
                        style={styles.input}
                        onPress={() => setGraphFromOpen(true)}
                      >
                        {isMobile
                          ? moment(graphFromDate).format("DD/MM/YY")
                          : moment(graphFromDate).format("DD/MM/YYYY")}
                      </Text>
                      <Text style={styles.error_text}>
                        {graphFromDateError}
                      </Text>
                    </View>
                  </View>
                  <DatePickerModal
                    locale="en"
                    mode="single"
                    visible={graphFromOpen}
                    onDismiss={onDismissGraphFrom}
                    date={graphFromDate}
                    onConfirm={onConfirmGraphFrom}
                    label="Select date" 
                    closeIcon="close"
                    calendarIcon="calendar"
                  />
                  <View
                    style={
                      isMobile
                        ? {
                            width: "45%",
                            backgroundColor: "#fff",
                            marginLeft: "-10%",
                          }
                        : {
                            width: "15%",
                            backgroundColor: "#fff",
                            marginLeft: 10,
                          }
                    }
                  >
                    <Text
                      style={
                        isMobile
                          ? { color: "#000000", fontSize: 12 }
                          : { color: "#000000" }
                      }
                    >
                      To Date
                    </Text>
                    <View
                      style={{
                        flexDirection: "column",
                        marginTop: 2,
                        backgroundColor: "#fff",
                      }}
                    >
                      <Text
                        style={styles.input}
                        onPress={() => setGraphToOpen(true)}
                      >
                        {isMobile
                          ? moment(graphToDate).format("DD/MM/YY")
                          : moment(graphToDate).format("DD/MM/YYYY")}
                      </Text>
                      <Text style={styles.error_text}>{graphToDateError}</Text>
                    </View>
                  </View>
                  <DatePickerModal
                    locale="en"
                    mode="single"
                    visible={graphToOpen}
                    onDismiss={onDismissGraphTo}
                    date={graphToDate}
                    onConfirm={onConfirmGraphTo}
                    label="Select date" 
                    closeIcon="close"
                    calendarIcon="calendar"
                  />
                  <View
                    style={
                      isMobile
                        ? {
                            width: "30%",
                            backgroundColor: "#fff",
                            marginLeft: "-10%",
                          }
                        : {
                            marginLeft: 10,
                            width: "15%",
                            backgroundColor: "#fff",
                          }
                    }
                  >
                    <Text
                      style={
                        isMobile
                          ? { color: "#000000", fontSize: 12 }
                          : { color: "#000000" }
                      }
                    >
                      Select Zone
                    </Text>
                    <Dropdown
                      style={styles.dropdown}
                      placeholderStyle={
                        isMobile ? { fontSize: 12 } : styles.placeholderStyle
                      }
                      selectedTextStyle={styles.selectedTextStyle}
                      inputSearchStyle={styles.inputSearchStyle}
                      iconStyle={styles.iconStyle}
                      data={ZoneNameData}
                      search
                      maxHeight={300}
                      labelField="zone_name"
                      valueField="zone_name"
                      placeholder={!isFocus ? "Select Zone Id" : "...."}
                      searchPlaceholder="Search..."
                      value={ZoneValue}
                      onChange={(item) => {
                        setZoneValue(item.zone_name);
                        setZoneValueId(item.id);
                        setSubzoneValue("All");
                        setSubzoneValueId(0);
                        setOmegaIdValue("All");
                        setOmegaValueiD(0);
                        setOmegaId("");
                        getDependentZoneMaster(item.id);
                        getOmegaDependentByProjectId(projectId, item.id, null);
                      }}
                      renderItem={renderZoneIdListItems}
                    />
                  </View>
                  <View
                    style={
                      isMobile
                        ? {
                            width: "30%",
                            backgroundColor: "#fff",
                            marginLeft: "-10%",
                          }
                        : {
                            marginLeft: 10,
                            width: "15%",
                            backgroundColor: "#fff",
                          }
                    }
                  >
                    <Text
                      style={
                        isMobile
                          ? { color: "#000000", fontSize: 12 }
                          : { color: "#000000" }
                      }
                    >
                      Select Subzone
                    </Text>
                    <Dropdown
                      ref={dropdownRefOmegaiD}
                      style={styles.dropdown}
                      placeholderStyle={
                        isMobile ? { fontSize: 12 } : styles.placeholderStyle
                      }
                      selectedTextStyle={styles.selectedTextStyle}
                      inputSearchStyle={styles.inputSearchStyle}
                      iconStyle={styles.iconStyle}
                      data={subzoneData}
                      search
                      maxHeight={300}
                      labelField="sub_zone_name"
                      valueField="sub_zone_name"
                      placeholder={!isFocus ? "Select subzone " : "...."}
                      searchPlaceholder="Search..."
                      value={SubzoneValue}
                      onChange={(item) => {
                        setSubzoneValue(item.sub_zone_name);
                        setSubzoneValueId(item.id);
                        setOmegaIdValue("All");
                        setOmegaValueiD(0);
                        setOmegaId("");
                        getOmegaDependentByProjectId(
                          projectId,
                          ZoneValueId,
                          item.id,
                        );
                      }}
                      renderItem={renderSubZoneIdListItems}
                    />
                  </View>

                  <View
                    style={
                      isMobile
                        ? {
                            width: "30%",
                            backgroundColor: "#fff",
                            marginLeft: "-10%",
                          }
                        : {
                            marginLeft: 10,
                            width: "15%",
                            backgroundColor: "#fff",
                          }
                    }
                  >
                    <Text
                      style={
                        isMobile
                          ? { color: "#000000", fontSize: 12 }
                          : { color: "#000000" }
                      }
                    >
                      Select Omega
                    </Text>
                    <Dropdown
                      ref={dropdownRefOmegaiD}
                      style={styles.dropdown}
                      placeholderStyle={
                        isMobile ? { fontSize: 12 } : styles.placeholderStyle
                      }
                      selectedTextStyle={styles.selectedTextStyle}
                      inputSearchStyle={styles.inputSearchStyle}
                      iconStyle={styles.iconStyle}
                      data={OmegaIdData}
                      search
                      maxHeight={300}
                      labelField="device_name"
                      valueField="device_name"
                      placeholder={!isFocus ? "Omega Device Type" : "...."}
                      searchPlaceholder="Search..."
                      value={OmegaIdValue}
                      onChange={(item) => {
                        setGraphOmegaIdValue(item.device_name);
                        setGraphOmegaValueiD(item.id);
                        if (FromDate === undefined && ToDate === undefined) {
                          setFromDateError("Please select from data");
                          setToDateError("Please select to date");
                        } else {
                          setGraphOmegaId(item.omega_id);
                          getProgramGraphData(item.omega_id);
                          setFromDateError("");
                          setToDateError("");
                        }
                      }}
                      renderItem={renderGraphOmegaIdListItems}
                    />
                  </View>
                </View>
                {isLoadingSync ? (
                  <ActivityIndicator
                    color="#1DA1F2"
                    visible={isLoadingSync}
                    textContent={"Loading..."}
                    size={100}
                  />
                ) : programGraphData.valveData !== undefined &&
                  programGraphData.valveData.length > 0 ? (
                  <View
                    style={{
                      height: windowHeight * 0.6,
                      width: windowWidth * 0.9,
                      padding: 20,
                      backgroundColor: "#fff",
                    }}
                  >
                    <Victory.VictoryChart
                      width={
                        programGraphData.dateCountArray.length <= 3
                          ? windowWidth * 0.4
                          : windowWidth * 0.9
                      }
                      domainPadding={{ x: 50, y: 25 }}
                      theme={Victory.VictoryTheme.grayscale}
                    >
                      <Victory.VictoryAxis
                        tickValues={programGraphData.dateCountArray}
                        tickFormat={programGraphData.dateArray}
                        fixLabelOverlap
                        label={"Dates"}
                        axisLabelComponent={
                          <Victory.VictoryLabel
                            style={{
                              fill: "#455A64",
                              fontSize: 13,
                              marginTop: 20,
                            }}
                            textAnchor={"middle"}
                          />
                        }
                        style={{
                          grid: { stroke: "#D5D5D5" },
                          ticks: { stroke: "#D5D5D5", size: 5 },
                          tickLabels: { fontSize: 13, padding: 5 },
                        }}
                      />
                      <Victory.VictoryAxis
                        dependentAxis
                        label={"Total Value, m³"}
                        axisLabelComponent={
                          <Victory.VictoryLabel
                            style={{ fill: "#455A64", fontSize: 13 }}
                            x={-2}
                            textAnchor={"middle"}
                          />
                        }
                        tickFormat={(x) => x}
                        style={{
                          grid: { stroke: "#D5D5D5" },
                          ticks: { stroke: "#D5D5D5", size: 5 },
                          tickLabels: { fontSize: 13, padding: 5 },
                        }}
                      />
                      <Victory.VictoryStack
                        colorScale={programGraphData.colorData}
                      >
                        {programGraphData?.valveData?.map((item, index) => {
                          return (
                            <Victory.VictoryBar
                              padding={{ left: 50 }}
                              labelComponent={<Victory.VictoryTooltip />}
                              alignment="middle"
                              barRatio={0.3}
                              key={index}
                              data={item.valve}
                              x="date"
                              y="value"
                            />
                          );
                        })}
                      </Victory.VictoryStack>
                    </Victory.VictoryChart>
                    {programGraphData.valveData.length > 0 && (
                      <View style={{ flexDirection: "row", marginBottom: 50 }}>
                        {programGraphData.valveData.map((item, index) => {
                          return (
                            <View
                              style={{ flexDirection: "row", marginStart: 20 }}
                            >
                              <IconFontAwesome
                                color={programGraphData.colorData[index]}
                                name="square"
                                size={20}
                              />
                              <Text
                                style={[
                                  styles.btnTextCancel,
                                  { textAlign: "left", marginLeft: 5 },
                                ]}
                              >
                                {
                                  programGraphData.valveData[index].valve[0]
                                    .valveName
                                }
                              </Text>
                            </View>
                          );
                        })}
                      </View>
                    )}
                  </View>
                ) : (
                  <View
                    style={{
                      height: windowHeight * 0.6,
                      width: windowWidth * 0.7,
                      backgroundColor: "#fff",
                    }}
                  >
                    <View
                      style={{
                        justifyContent: "center",
                        backgroundColor: "#fff",
                      }}
                    >
                      <Text
                        style={[
                          styles.emptyListStyle,
                          { alignSelf: "center", marginTop: 20 },
                        ]}
                      >
                        No data Found
                      </Text>
                    </View>
                  </View>
                )}
              </View>
            </View>
          )}
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    height: "100%",
  },
  itemStyle: {
    padding: 10,
  },
  textInputStyle: {
    height: 35,
    borderWidth: 2,
    paddingLeft: 20,
    borderRadius: 5,
    borderColor: "#319ef0",
    backgroundColor: "#FFFFFF",
    width: "40%",
    fontWeight: "400",
  },
  tableHead: {
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "700",
    color: "#000000",
  },

  containeralt: {
    backgroundColor: "white",
    borderColor: "#eee",
    borderRadius: 10,
    borderWidth: 1,
    height: 300,
    margin: "auto",
    padding: 30,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: "30%",
  },
  contanerSwitch: {
    backgroundColor: "white",
    borderColor: "#eee",
    borderRadius: 5,
    alignSelf: "center",
    borderWidth: 1,
    height: "25%",
    margin: "auto",
    padding: 10,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: "30%",
  },
  tableHeader: {
    color: "#000",
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "400",
  },
  input: {
    borderColor: "#c3c3c3",
    width: "100%",
    borderWidth: 1,
    borderRadius: 4,
    color: "#000000",
    padding: 10,
    marginBottom: 6,
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  alertBtn: {
    alignItems: "center",
    backgroundColor: "#747474",
    padding: 10,
    borderWidth: 1,
    borderColor: "#747474",
    borderRadius: 10,
  },
  alertBtnAfter: {
    alignItems: "center",
    backgroundColor: "#fff",
    padding: 10,
    borderWidth: 1,
    borderColor: "#747474",
    width: "33%",
    borderRadius: 10,
  },
  saveBtn: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "50%",
    marginRight: 10,
  },
  btnText: {
    color: "#fff",
    fontWeight: "600",
  },
  btnTextAfter: {
    color: "#000",
    fontWeight: "600",
  },
  card: {
    width: "70%",
    flex: 1,
    marginVertical: 10,
  },
  shadowProp: {
    shadowColor: "#171717",
    shadowOffset: { width: -2, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 15,
  },
  error_text: {
    color: "red",
    fontSize: 14,
    fontWeight: "600",
    width: "70%",
    marginLeft: 0,
    marginBottom: 10,
  },

  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  linkText: {
    fontSize: 14,
    color: "#2e78b7",
  },

  dropdown: {
    borderColor: "#c3c3c3",
    borderWidth: 1,
    borderRadius: 2,
    height: 40,
    marginLeft: 0,
    outlineStyle: "none",
    padding: 10,
    marginTop: 5,
    marginBottom: 5,

  },
  icon: {
    marginRight: 5,
  },
  item: {
    padding: 9,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  textItem: {
    flex: 1,
    fontSize: 12,
  },
  placeholderStyle: {
    fontSize: 12,
  },
  selectedTextStyle: {
    fontSize: 12,
  },
  iconStyle: {
    width: 20,
    height: 20,
  },
  inputSearchStyle: {
    height: 30,
    fontSize: 12,
    outlineStyle: "none",
  },
  emptyListStyle: {
    padding: 20,
    fontSize: 20,
    textAlign: "center",
  },
  lableText: {
    color: "#484848",
    fontWeight: "700",
    marginTop: 18,
  },
  btnTextCancel: {
    color: "#747474",
    fontWeight: "600",
    textAlign: "center",
  },
});
